import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../api/api';

const SeasonSelector = ({ selectedSeasonId, onSeasonChange }) => {
  const { t } = useTranslation();
  const [seasons, setSeasons] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get('/seasons');
        setSeasons(res.data);
        if (!selectedSeasonId) {
          const active = res.data.find(s => s.isActive);
          if (active) onSeasonChange(active.id);
          else if (res.data.length > 0) onSeasonChange(res.data[0].id);
        }
      } catch (err) { /* ignore */ }
    };
    fetch();
  }, []);

  return (
    <select
      value={selectedSeasonId || ''}
      onChange={(e) => onSeasonChange(parseInt(e.target.value))}
      className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
    >
      {seasons.map(s => (
        <option key={s.id} value={s.id}>
          {s.name} {s.isActive ? `(${t('analytics.active')})` : ''}
        </option>
      ))}
    </select>
  );
};

export default SeasonSelector;
